// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Route, Switch} from 'react-router-dom'
import ChangePassword from '../ChangePassword'
import Modal from '../Modal'
import ToggleContent from '../Toggle'
import history from '../../history'

import Page from '../Page'
import SideNavBar, {navItem} from '../SideNavBar'

import AuditViewer from '../AuditViewer'
import {AUDITVIEWER_PATH} from '../AuditViewer/navigation'

import MultiDRM from '../MenuItem/MultiDRM'
import {MULTIDRM_PATH} from '../MenuItem/MultiDRM/navigation'

import Analytics from '../MenuItem/Analytics'
import {ANALYTICS_PATH, SERVICES_PATH, MULTIDRM_ACTIVITY_PATH, IPTV_ACTIVITY_PATH, OTT_ACTIVITY_PATH, API_ACTIVITY_PATH} from '../MenuItem/Analytics/navigation'

import LookerDashboard, {dashboards_ids} from '../LookerDashboard'

import ComponentSpinner from '../Spinner/ComponentSpinner/'

import ProtectMyApp from '../MenuItem/ProtectMyApp'
import NTitleMe from '../MenuItem/NTitleMe'
import StreamMark from '../MenuItem/StreamMark'
import StrongAuthentication from '../MenuItem/StrongAuthentication'
import ContentDistribution from '../MenuItem/ContentDistribution'
import UserManagement from '../UserManagement'
import MyProfile from '../MyProfile'
import Devices from '../MenuItem/MultiDRM/VCASCloud/Devices/'
import Entitlements from '../MenuItem/MultiDRM/VCASCloud/Entitlements/'

import config, {FEATURE_AUDIT_VIEWER, FETAURE_USER_MANAGEMENT_PRODUCTS,
  FEATURE_USER_MANAGEMENT_PROFILES, FEATURE_MY_PROFILE, FEATURE_VCASCLOUD_DEVICES} from '../../config'

import {VCASCLOUD_PATH, DEVICES_PATH, ENTITLEMENTS_PATH} from '../MenuItem/MultiDRM/VCASCloud/navigation'

// Import Icons
import {ReactComponent as MultiDRMIcon} from '../../media/icons/multi-drm-icon.svg'
import {ReactComponent as AnalyticsIcon} from '../../media/icons/analytics-icon.svg'
import {ReactComponent as CodeProtectionIcon} from '../../media/icons/code-protection-icon.svg'
import {ReactComponent as NtitleMeIcon} from '../../media/icons/n-title-me-icon.svg'
import {ReactComponent as WatermarkingIcon} from '../../media/icons/watermarking-icon.svg'
import {ReactComponent as StrongAuthenticationIcon} from '../../media/icons/strong-authentication-icon.svg'
import {ReactComponent as ContentDistributionIcon} from '../../media/icons/content-distribution-icon.svg'

import './index.css'

const audit_viewer_flag = config[FEATURE_AUDIT_VIEWER]
const my_profile_flag = config[FEATURE_MY_PROFILE]
const profiles_flag = config[FEATURE_USER_MANAGEMENT_PROFILES]
const products_flag = config[FETAURE_USER_MANAGEMENT_PRODUCTS]
const devices_flag = config[FEATURE_VCASCLOUD_DEVICES]

export default class UnifiedPortal extends Component {

  renderModal = () => {
    return (
      <ToggleContent
        toggle={show => <button onClick={show}>Open</button>}
        content={hide => (
          <Modal onHide={hide}>
            <ChangePassword onHide={hide}/>
          </Modal>
        )}
      />
    )
  }

  renderRouteSwitch () {
    return (
      <div className='content'>
        <Switch>
          <Route path={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${API_ACTIVITY_PATH}/`} render={(props) => <LookerDashboard {...props} dashboardId={dashboards_ids.api_activity} />}/>
          <Route path={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${MULTIDRM_ACTIVITY_PATH}/`} render={(props) => <LookerDashboard {...props} dashboardId={dashboards_ids.multidrm_activity} />}/>
          <Route path={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${OTT_ACTIVITY_PATH}/`} render={(props) => <LookerDashboard {...props} dashboardId={dashboards_ids.ott_activity} />}/>
          <Route path={`/${ANALYTICS_PATH}/${SERVICES_PATH}/${IPTV_ACTIVITY_PATH}/`} render={(props) => <LookerDashboard {...props} dashboardId={dashboards_ids.iptv_activity} />}/>
          <Route path={`/${MULTIDRM_PATH}/${VCASCLOUD_PATH}/${ENTITLEMENTS_PATH}/`} component={Entitlements}/>
          {devices_flag && <Route path={`/${MULTIDRM_PATH}/${VCASCLOUD_PATH}/${DEVICES_PATH}/`} component={Devices}/>}
          {audit_viewer_flag && <Route path={`/${MULTIDRM_PATH}/${AUDITVIEWER_PATH}/`} component={AuditViewer}/>}
          {my_profile_flag && <Route path='/my-profile/' component={MyProfile}/>}
          {(profiles_flag || products_flag) && <Route path='/user-management/' component={UserManagement}/>}
          <Route path={`/${MULTIDRM_PATH}/`} component={MultiDRM}/>
          <Route path={`/${ANALYTICS_PATH}/`} component={Analytics}/>
          <Route path='/protect-my-app/' component={ProtectMyApp}/>
          <Route path='/ntitle-me/' component={NTitleMe}/>
          <Route path='/stream-mark/' component={StreamMark}/>
          <Route path='/strong-authentication/' component={StrongAuthentication}/>
          <Route path='/content-distribution/' component={ContentDistribution}/>
          <Route path='/' render={() => <>{history.push('/multi-drm/')}</>} />
        </Switch>
      </div>
    )
  }

  render () {
    const locations = ['multi-drm', 'analytics', 'protect-my-app', 'ntitle-me', 'stream-mark', 'strong-authentication', 'content-distribution']
    const location = this.props.location.pathname.split('/')[1]
    const selected = locations.includes(location) ? location : null

    return (
      <Page>
        <div className='status-screen'>
          <div className='row status-screen-content'>
            <SideNavBar selected={selected}>
              {navItem(MULTIDRM_PATH, <MultiDRMIcon/>, 'Multi DRM', 'mt-5')}
              {navItem('analytics', <AnalyticsIcon/>, 'Analytics')}
              {navItem('protect-my-app', <CodeProtectionIcon/>, 'Code Protection')}
              {navItem('ntitle-me', <NtitleMeIcon/>, 'TV Authentication')}
              {navItem('stream-mark', <WatermarkingIcon/>, 'Watermarking')}
              {navItem('strong-authentication', <StrongAuthenticationIcon/>, 'Strong Authentication')}
              {navItem('content-distribution', <ContentDistributionIcon/>, 'Content Distribution')}
            </SideNavBar>
            <div className='col switch'>
              <ComponentSpinner
                distance={['1vw', '3vw', '5vw']}
              />
              {this.renderRouteSwitch()}
            </div>
          </div>
        </div>
      </Page>
    )
  }
}
